import React from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
import HomePageOne from "../page/home/HomePageOne";
import SeoHelmet from "../../seo/SeoHelmet";
import {
  DEFAULT_DESCRIPTION,
  DEFAULT_TITLE,
  homeJsonLd,
} from "../../seo/seoConfig";

function MainLayout() {
  return (
    <>
      <SeoHelmet
        title={DEFAULT_TITLE}
        description={DEFAULT_DESCRIPTION}
        path="/"
        jsonLd={homeJsonLd()}
      />
      <Header />
      <HomePageOne />
      <Footer />
    </>
  );
}

export default MainLayout;
